<template>
    <div class="card" style="width: 22rem;">
        <div class="card-body">
            <h5 class="card-title">Policy excess</h5>
            <hr />
            <div v-if="policyDetails">
                <div class="row">
                    <div class="col">
                        <p class="card-text font-weight-bold">Waived</p>
                    </div>
                    <div class="col">
                        <p class="card-text font-weight-light">{{isExcessWaived}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p class="card-text font-weight-bold">MultiXS</p>
                    </div>
                    <div class="col">
                        <p class="card-text font-weight-light">{{isMultiXS}}</p>
                    </div>
                </div>
                <div v-if="policyDetails.isMultiXS" class="row">
                    <div class="col">
                        <p class="card-text font-weight-bold">Selected excess</p>
                    </div>
                    <div class="col">
                        <p class="card-text font-weight-light">&pound;{{formatNumber2(policyDetails.selectedExcess)}}</p>
                    </div>
                </div>
            </div>
            <div v-else class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const formatNumber = (dec) => (val) => {
    if (!isNaN(parseFloat(val)))
    {
        return val.toFixed(dec)
    }
    else
    {
        return 0
    }
}

export default {
    name: 'PolicyExcessInfo',
    computed: {
        selectedClaim()
        {
            return this.$store.getters.selectedClaim
        },
        policyDetails()
        {
            if (this.selectedClaim) {
                if (this.selectedClaim.policyDetails) {
                    return this.selectedClaim.policyDetails 
                }
            }
            return null
        },
        isExcessWaived() {
            if (this.policyDetails && this.policyDetails.deserialisedObject) {
                return this.formatBool(this.policyDetails.deserialisedObject.isExcessWaived)
            }
            return 'UNKNOWN'
        },
        isMultiXS() {
            if (this.policyDetails) {
                return this.formatBool(this.policyDetails.isMultiXS)
            } else {
                return 'UNKNOWN'
            }
        }
     },
     methods: {
        formatNumber2(val)
        {
            return formatNumber(2)(val)
        },
        formatBool(val) {
            if (val === true) {
                return 'YES'
            } else if ( val === false) {
                return 'NO'
            } else {
                return 'UNKNOWN'
            }
        }
     }
}
</script>